
import { Mixins, Component, Ref, Prop, Watch } from "vue-property-decorator";
import loading from "@/mixins/loading";
import { Form } from "element-ui/types";
import {
  updateWeigherMetabolismConfig
} from "@/api/weigherMetabolismConfig";

@Component({ name: 'ai-evaluation-weight-components-editDialog', components: {} })
export default class EditDialog extends Mixins(loading) {
  @Ref("validateForm") validateForm: Form;
  @Prop([Boolean]) private dialogVisible!: boolean;
  @Prop([Object]) private row!: any;

  formData = {
    resultKey1: "",
    resultKey2: "",
    symptoms: "",
    reasons: "",
    preventDiseases: "",
  };

  rules = {
    symptoms: [
      { required: true, message: "请输入症状", trigger: "blur" },
    ],
    reasons: [
      { required: true, message: "请输入原因", trigger: "blur" },
    ],
    preventDiseases: [
      { required: true, message: "请输入预防疾病", trigger: "blur" },
    ],
  };

  dialogClose() {
    this.validateForm?.resetFields();
    this.$emit('closeEditDialog');
  }

  saveData() {
    this.validateForm?.validate().then((valid) => {
      if (valid) {
        const params = {
          id: this.row.id,
          symptoms: this.formData.symptoms,
          reasons: this.formData.reasons,
          preventDiseases: this.formData.preventDiseases,
        };
        this.showLoading();
        updateWeigherMetabolismConfig(params).then(() => {
          this.$message.success("保存成功");
          this.$emit('editDialogConfirm');
        }).finally(() => {
          this.hideLoading();
        });
      }
    });
  }

  @Watch("dialogVisible", { immediate: true })
  initData() {
    if (this.dialogVisible !== true || !this.row) return;
    this.formData = {
      resultKey1: this.row.resultKey1 || "",
      resultKey2: this.row.resultKey2 || "",
      symptoms: this.row.symptoms || "",
      reasons: this.row.reasons || "",
      preventDiseases: this.row.preventDiseases || "",
    };
  }
}
